import React, { useState } from "react";
import MenuBar from "../components/MenuBar";
import NaverMapRoute from "../NaverMapRoute";

const MapExample = () => {
  const [route, setRoute] = useState(null);

  return (
    <div>
      <MenuBar onRoute={setRoute} />
      {route ? (
        <NaverMapRoute start={route.start} goal={route.goal} />
      ) : (
        <div
          style={{
            width: "100%",
            height: "500px",
            backgroundColor: "#1E2027",
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "18px",
          }}
        >
          출발지와 목적지를 입력 후 길찾기를 눌러주세요 🚀
        </div>
      )}
    </div>
  );
};

export default MapExample;
